import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';

export const Divider = styled.div`
    background-color: ${theme.colors.border.muted};
    height: 1px;
    margin-top: ${theme.space[4]};
    width: 100%;
`;
